/**
 * Small "Inquire on WhatsApp" button used on product/spare cards.
 * Builds a wa.me link with a pre-filled message containing the item title.
 * Hidden if the site's whatsapp_number is empty or whatsapp_enabled is false.
 */
import { useSettings } from "@/lib/settings";

export default function WhatsAppInquireButton({ itemTitle, kind = "product", className = "" }) {
  const { settings } = useSettings();
  if (!settings) return null;
  if (settings.whatsapp_enabled === false) return null;
  const num = (settings.whatsapp_number || "").replace(/[^0-9]/g, "");
  if (!num) return null;
  const label = kind === "spare" ? "spare part" : "machine";
  const msg = encodeURIComponent(`Hi Tara Autohub, I'm interested in this ${label}: "${itemTitle}". Please share price, availability & delivery details.`);
  const href = `https://wa.me/${num}?text=${msg}`;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(href, "_blank", "noopener,noreferrer");
      }}
      className={`inline-flex items-center justify-center gap-1.5 bg-[#25D366] hover:bg-[#1ebe5b] text-white text-[11px] font-heading font-black uppercase tracking-widest px-3 py-2 transition-colors ${className}`}
      data-testid="whatsapp-inquire-btn"
      aria-label={`Inquire about ${itemTitle} on WhatsApp`}
    >
      <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="currentColor" aria-hidden="true">
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zM18.06 13.708l-.123-.038c-.293-.146-1.733-.854-2-.952-.268-.099-.464-.146-.66.146-.196.293-.756.952-.927 1.146-.171.196-.342.219-.635.073-.293-.146-1.237-.456-2.356-1.454-.871-.776-1.459-1.733-1.629-2.026-.171-.293-.018-.451.128-.597.131-.13.293-.342.439-.512.146-.171.196-.293.293-.488.097-.196.049-.366-.024-.512-.073-.146-.66-1.586-.904-2.171-.237-.57-.479-.493-.66-.502l-.561-.01c-.196 0-.512.073-.781.366-.268.293-1.025.999-1.025 2.439 0 1.439 1.05 2.831 1.196 3.026.146.196 2.063 3.149 5 4.418.699.301 1.244.482 1.67.617.701.223 1.339.192 1.844.117.563-.084 1.733-.708 1.978-1.392.244-.683.244-1.269.171-1.392-.073-.123-.268-.196-.561-.342z"/>
      </svg>
      WhatsApp
    </button>
  );
}
